/**
 * klubb-plp — PLP-only behavior. Mobile filter drawer toggle.
 */

function wireFilterDrawer() {
  // Delegated: the close button at the bottom of the form is re-rendered by
  // klubb-plp-filter.js on every in-place filter swap.
  document.addEventListener('click', (event) => {
    const opener = event.target.closest && event.target.closest('[data-klubb-filters-open]');
    if (opener) {
      const drawer = document.getElementById(opener.getAttribute('aria-controls'));
      if (!drawer) return;
      drawer.classList.add('is-open');
      opener.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      return;
    }
    const closer = event.target.closest && event.target.closest('[data-klubb-filters-close]');
    if (closer) {
      const drawer = closer.closest('[data-klubb-filters]');
      if (!drawer) return;
      drawer.classList.remove('is-open');
      const btn = document.querySelector(`[aria-controls="${drawer.id}"]`);
      if (btn) btn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  });
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireFilterDrawer);
  } else {
    wireFilterDrawer();
  }
}
